import { IUserInfo, UserRole } from 'gen/ApiClient';

export const userToSelectableRoles = (user: IUserInfo): UserRole[] => {
	if (user.role === ('SuperUser' as UserRole)) {
		return ['Normal', 'Admin', 'SuperUser'];
	} else {
		return ['Normal'];
	}
};
